export default {"src":"/_next/static/image/public/images/ic_hand_sanitize.3872d1652f2a3b606eb6f9e7af65ecff.svg","height":26,"width":25};